import { useEffect, useRef, useState } from "preact/hooks";
import { JSX } from "preact/jsx-runtime";
import { useNotification } from "../../shared/contexts";
import { Box, Typography } from "../../shared/ui";
import { Icon } from "../Icon";
import css from "./Copy.module.scss";

export interface CopyProps {
  className?: string;
  firstItem?: JSX.Element;
  secondItem?: JSX.Element;
  copyText: string;
}

export const Copy = ({ firstItem, secondItem, copyText }: CopyProps) => {
  const { showInfo } = useNotification();
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<number | null>(null);

  const handleClick = () => {
    navigator.clipboard.writeText(copyText);
    showInfo("Copied to clipboard");
    setCopied(true);

    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = window.setTimeout(() => setCopied(false), 3000);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);

  const iconColor = copied ? "#5AC8FA" : "#707071";

  return (
    <button className={css.container} onClick={handleClick}>
      <Box className={css.firstCol}>
        {firstItem}
        <Box className={css.wrapper}>
          {secondItem}
          <Typography className={css.text} variant="caption2" color="blue">
            {copyText}
          </Typography>
        </Box>
      </Box>
      <Icon name="copy" width={28} height={28} color={iconColor} />
    </button>
  );
};
